import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { UIMenu, UIMenuItem } from '@futrli/ui-components';

import { INTERCOM_LAUNCHER_ID, ZEN_DESK_URL } from '../../../../../../skeleton/src/core/constants';

import styles from './help-menu-content.scss';

export interface HelpMenuContentProps {
  anchorElement: HTMLElement | null;
  onClose: () => void;
  onHelpCentreClick: () => void;
  onIntercomMenuClick: () => void;
}

export const HelpMenuContent = ({
  anchorElement,
  onClose,
  onHelpCentreClick,
  onIntercomMenuClick
}: HelpMenuContentProps) => {
  const intl = useIntl();

  return (
    <UIMenu
      open={Boolean(anchorElement)}
      anchorEl={anchorElement}
      onClose={onClose}
      disableAutoFocusItem={true}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      classes={{ paper: styles.newMenu }}
      aria-label={intl.formatMessage({ id: 'common.user_help_menu.aria_label', defaultMessage: 'User Help menu' })}
      disablePortal
    >
      <UIMenuItem className={styles.uiNewMenuItem}>
        <a href={ZEN_DESK_URL} target="_blank" rel="noopener noreferrer" onClick={onHelpCentreClick}>
          <FormattedMessage id="common.help_centre" defaultMessage="Help centre" />
        </a>
      </UIMenuItem>

      <UIMenuItem className={styles.uiNewMenuItem}>
        <a onClick={onIntercomMenuClick} id={INTERCOM_LAUNCHER_ID}>
          <FormattedMessage id="common.ask_question" defaultMessage="Ask us a question" />
        </a>
      </UIMenuItem>
    </UIMenu>
  );
};
